import * as routes from "utils/contants/urls";

import {
  ActionItem,
  Actions,
  Label,
  LabelAction,
  LabelHeader,
  Table,
  TableBody,
  TableColumn,
  TableHead,
  TableRow

} from "components/shared/CustomComponentsStyle";
import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import {
  view
} from "assets/icons/icons";
import { Creators as formInputsActions } from "store/ducks/formInputs";
import { Body } from "./ListDocumentsCandidatesStyle";
import BreadCrumb from "components/Layout/breadcrumb";

import { MultSelectCreatable, MultSelect, CheckBox, ButtonSecondary, DatePicker, TextField } from "components/shared/CustomInputs";
import { Collapse } from "components/shared/CustomComponents";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";
import Load from "components/Layout/Load";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Creators as documentsAction } from "store/ducks/documents";
import { Creators as candidatesAction } from "store/ducks/candidates";
import { StatusEtapaDocumentos } from "utils/contants/enums";
import { Creators as messageAction } from "store/ducks/messages";
import Pagination from "components/Pagination";

const RowColorStage = (status) => {

  let color;
  switch (status) {
    case "Em análise":
      color = "#f44336";
      break;
    case "Aprovado":
      color = "rgb(95 227 100)";
      break;
    case "Desistente":
      color = "#86868666";
      break;
    case "Pendente de reenvio":
      color = "#A020F0";
      break;
    default:
      color = "orange";
      break;
  }


  return ({
    height: '18px',
    width: '18px',
    borderRadius: '50%',
    float: 'left',
    display: 'inline-block', backgroundColor: color
  });
};

const redirect = (url) => {
  window.location.href = url;
};

const ListDocumentsCandidates = ({
  candidateVacancysDocs,
  candidates,
  isLoading,
  pagination,
  location,
  requestInputValues,
  placesOfWork,
  messagePublication,
  hasMore,
  releaseStageForCandidatesRequest,
  requestExportPersonalInformations,
  releaseCancellationForCandidatesRequest,
  releasePasswordReset,
}) => {
  const [selectAll, setSelectAll] = useState(false);
  const [agruparPorVaga, setAgruparPorVaga] = useState(false);
  const [clearFilter, setClearFilter] = useState(false);
  const [formValues, setFormValues] = useState({ cpfs: [], idVagas: [], idLocations: [], dataAdmissao: "", nomeFuncionario: ""});
  const [erroMessage, setErroMessage] = useState({ message: "" });
  const [contextCandidates, setContextCandidates] = useState([]);

  const AplicaFiltro = (form, firstPage) => {
    localStorage.setItem("filter_ListDocumentsCandidates", JSON.stringify(form));
    candidateVacancysDocs({
      nomeFuncionario: form.nomeFuncionario,
      cpfList: form.cpfs,
      idVagasList: form.idVagas,
      idLocaisList: form.idLocations,
      dataAdmissaoPrevista: form.dataAdmissao,
      idStatusList: form.idStatus,
      dateInitActivity: form.dateInitActivity,
      firstPage
    });
    setFormValues(form);
  };

  const loadMore = () => {
    setClearFilter(false);
    AplicaFiltro(formValues, false);
  };

  useEffect(() => {
    requestInputValues(["placeOfWork"]);
    let filter_storaged = JSON.parse(localStorage.getItem("filter_ListDocumentsCandidates"));

    if (filter_storaged != null) {
      setFormValues(filter_storaged);
      candidateVacancysDocs({
        cpfList: filter_storaged.cpfs, idVagasList: filter_storaged.idVagas,
        idLocaisList: filter_storaged.idLocations, idStatusList: filter_storaged.idStatus, dateInitActivity: filter_storaged.dateInitActivity,
        firstPage: true, recoveredFilter: true, quantidadeItens: filter_storaged.quantidadeItens
      });

    } else {
      candidateVacancysDocs({ cpfs: [], idVagas: [], idLocations: [], firstPage: true });
    }
  }, []);

  useEffect(() => {
    if (candidates.candidatos != undefined && candidates.candidatos.length) {
      const dupContextList = candidates.candidatos.map(candidate => {
        return { ...candidate, selected: false};
      });

      setContextCandidates(dupContextList);
    }

    let filter_storaged = JSON.parse(localStorage.getItem("filter_ListDocumentsCandidates"));
    if (filter_storaged != null && !clearFilter) {
      filter_storaged.quantidadeItens = candidates.candidatos ? candidates.candidatos.length : 20;
      localStorage.setItem("filter_ListDocumentsCandidates", JSON.stringify(filter_storaged));
      setFormValues(filter_storaged);
    } else {
      setFormValues({ cpfs: [], idVagasList: [], idVagas: [], idLocations: [], idStatus: [], dateInitActivity: null });
    }

if (candidates.candidatos == undefined) {
      AplicaFiltro(formValues, true);
    }

  }, [candidates]);

  const Filtrar = () => {
    setClearFilter(false);
    AplicaFiltro(formValues, true);
  };

  const getStatusEtapaValues = () => {
    if (formValues.idStatus) {
      return StatusEtapaDocumentos.filter(function (item) {
        return formValues.idStatus.indexOf(item.value) !== -1;
      });
    }

    return [];
  }

  const LimparFiltro = () => {
    setClearFilter(true);
    localStorage.removeItem("filter_ListDocumentsCandidates");
    setFormValues({});
    AplicaFiltro({}, true);
  };

  const TrataMultiInsert = Insert => {
    setErroMessage({ message: "" });
    let messages = [];
    let result = [];
    Insert.map(item => {
      let conc = item.value.trim().split(/[\s,]+/);
      conc.map(filtItem => {
        let concFiltered = filtItem.replace(/\D/g, ''); 
        if (concFiltered.length === 11) {
          result.push(concFiltered);
        } else {
          messages.push({ message: `CPF ${filtItem} precisa ter 11 dígitos. Não será considerado no filtro.`, type: "warning" });
        }
      });
    });
    messagePublication(messages);
    return result;
  };

  const selectCandidate = id => {
    const dupContextList = contextCandidates.map(item => {
      if (item.idCandidatoNaEtapa === id) {
        item.selected = !item.selected;
      }
      return item;
    });
    setContextCandidates(dupContextList);
  };

  const liberarCandidatos = () => {
    const selectedCandidates = contextCandidates.filter(candidate => candidate.selected).map(candidate => { return candidate.idCandidatoNaEtapa });
    releaseStageForCandidatesRequest({idsCandidatosEtapa: selectedCandidates});
  };

  const exportarCandidatos = () => {
    const selectedCandidates = contextCandidates.filter(candidate => candidate.selected).map(candidate => { return candidate.id });
    requestExportPersonalInformations(selectedCandidates);
  };

  const cancelarCandidatos = () => {
    const selectedCandidates = contextCandidates.filter(candidate => candidate.selected).map(candidate => { return candidate.idCandidatoNaEtapa });
    releaseCancellationForCandidatesRequest({idsCandidatosEtapa: selectedCandidates});
  };

  const resetarSenhaCandidato = () => {
    const selectedCandidates = contextCandidates.filter(candidate => candidate.selected).map(candidate => { return candidate.id });
    releasePasswordReset(selectedCandidates);
  };

  const requestPage = (filter) => { 
    candidateVacancysDocs({ NumeroPagina: filter.NumeroPagina});
  };

  const renderTableItems = (candidatesList) =>
    candidatesList.map((candidate) => (
      <TableRow>
        <TableColumn ta="center">
          <CheckBox
            onChange={() => selectCandidate(candidate.idCandidatoNaEtapa)}
            checked={candidate.selected}
          />
          <Label>{candidate.code}</Label>
        </TableColumn>
        <TableColumn>
          <span
            class="dot"
            style={RowColorStage(candidate.statusCandidatoNaEtapa)}
          />
          <Label>{candidate.cpf}</Label>
        </TableColumn>
        <TableColumn ta="left">
          <Label>{candidate.nome}</Label>
        </TableColumn>
        <TableColumn ta="left">
          <Label>{candidate.dataAdmissaoPrevista}</Label>
        </TableColumn>
        <TableColumn ta="left">
          <Label>{candidate.statusCandidatoNaEtapa}</Label>
        </TableColumn>
        <TableColumn ta="right" action>
          <Link
            onClick={() =>
              redirect(`${routes.DOCUMENTS_LIST}/${candidate.idCandidatoNaEtapa}`)
            }
          >
            <Actions flexPosition="flex-start">
              <ActionItem>
                {view()}
                <LabelAction>
                  <FormattedMessage id="sharedItems.view" />
                </LabelAction>
              </ActionItem>
            </Actions>
          </Link>
        </TableColumn>
      </TableRow>
    ));

  const renderCandidatesTable = (candidatesList) => {
    return (
      <>
      <Table>
        <TableBody>
          <TableRow noBorder>
            <TableHead>
              <LabelHeader>
                Selecionar
              </LabelHeader>
            </TableHead>
            <TableHead>
              <LabelHeader>
                <FormattedMessage id="documentsCandidateList.cpf" />
              </LabelHeader>
            </TableHead>
            <TableHead ta="left">
              <LabelHeader>
                <FormattedMessage id="documentsCandidateList.nomeCandidato" />
              </LabelHeader>
            </TableHead>
            <TableHead ta="left">
              <LabelHeader>
                <FormattedMessage id="documentsCandidateList.dataAdmissaoPrevista" />
              </LabelHeader>
            </TableHead>
            <TableHead ta="left">
              <LabelHeader>
                <FormattedMessage id="documentsCandidateList.status" />
              </LabelHeader>
            </TableHead>
            <TableHead ta="left">
              <LabelHeader>
                <FormattedMessage id="documentsCandidateList.documents" />
              </LabelHeader>
            </TableHead>
          </TableRow>
          {renderTableItems(contextCandidates)}
        </TableBody>
      </Table>
      <Pagination getItemsPage={requestPage} pageSize={50} {...pagination } />
      </>
    )
  };

  const renderCandidatesByGroupTable = candidatesList =>
  candidatesList.candidatosPorVaga.map(candidate => (
    <Collapse
      typeStatus={0}
      position={0}
      title={`Vaga ${candidate.idVaga} - ${candidate.nomeVaga}`}
    >
      <Table>
        <TableBody>
          <TableRow noBorder>
            <TableHead>
              <LabelHeader>
                <FormattedMessage id="documentsCandidateList.cpf" />
              </LabelHeader>
            </TableHead>
            <TableHead ta="left">
              <LabelHeader>
                <FormattedMessage id="documentsCandidateList.nomeCandidato" />
              </LabelHeader>
            </TableHead>
            <TableHead ta="left">
              <LabelHeader>
                <FormattedMessage id="documentsCandidateList.documentosEnviados" />
              </LabelHeader>
            </TableHead>
            <TableHead ta="left">
              <LabelHeader>
                <FormattedMessage id="documentsCandidateList.status" />
              </LabelHeader>
            </TableHead>
            <TableHead ta="left">
              <LabelHeader ta="center">
                <FormattedMessage id="documentsCandidateList.analisar" />
              </LabelHeader>
            </TableHead>
          </TableRow>
          {renderTableItems(candidate.candidatesByVacancyList)}
        </TableBody>
      </Table>
    </Collapse>
  ));

  if (isLoading) return <Load isLoading={isLoading} />;
  return (
    <React.Fragment>
      <BreadCrumb
        location={location}
        title={<FormattedMessage id="menuTalentBar.selectCandidate" />}
      />
      <Body>
          <Row style={{display:"flex", justifyContent:"flex-start"}}>
          <Col md={3}>
            <MultSelectCreatable
              key={5}
              name={<FormattedMessage id="documentsCandidateList.filterCpf" />}
              label={<FormattedMessage id="documentsCandidateList.filterCpf" />}
              isMulti
              options={formValues.cpfs}
              value={
                formValues.cpfs
                  ? formValues.cpfs.map((e) => ({
                      label: e,
                      value: e,
                    }))
                  : []
              }
              onChange={(e) =>
                setFormValues({
                  ...formValues,
                  cpfs: e ? TrataMultiInsert(e) : [],
                })
              }
            />
          </Col>
          <Col md={3}>
            <MultSelect
              name={<FormattedMessage id="contracts.statusEtapa" />}
              options={StatusEtapaDocumentos}
              label={<FormattedMessage id="contracts.statusEtapa" />}
              isMulti
              value={getStatusEtapaValues()}
              onChange={e =>
                setFormValues({
                  ...formValues,
                  idStatus: e
                    ? e.map(k => {
                      return k.value;
                    })
                    : []
                })
              }
            />
          </Col>
          <Col md={3}>
            <DatePicker
              width="223px"
              value={formValues.dataAdmissao}
              label="Data Admissão Prevista"
              max="2099-12-31"
              min="2023-01-01"
              onChange={(e) => {
                const year = e.target.value.split("-")[0];
                if (year === "" || parseInt(year) > 2099) return;
                setFormValues({
                  ...formValues,
                  dataAdmissao: e.target.value
                });
              }}
            />
          </Col>
          <Col md={3}>
            <TextField
              name={<FormattedMessage id="Nome Funcionário" />}
              label={<FormattedMessage id="Nome Funcionário" />}
              defaultValue={formValues.nomeFuncionario}
              value={formValues.nomeFuncionario}
              placeholder=""
              onChange={(e) =>
                e.target.value
                  ? setFormValues({
                      ...formValues,
                      nomeFuncionario: e.target.value,
                    })
                  : null
              }
            />
          </Col>
          </Row>

          <Row style={{display:"flex", justifyContent:"flex-start"}}>
          <Col md={3} style={{ marginTop: "15px" }}>
            <ButtonSecondary
              onClick={() => Filtrar()}
              name={<FormattedMessage id="sharedItems.filter" />}
            />
          </Col>
          <Col md={3} style={{ marginTop: "15px" }}>
            <ButtonSecondary
              onClick={() => LimparFiltro()}
              name={<FormattedMessage id="sharedItems.clearFilter" />}
            />
          </Col>
          <Col md={3} style={{ marginTop: "13px" }}>
            <CheckBox
              checked={selectAll}
              label={<FormattedMessage id="SELECIONAR TODOS" />}
              onChange={() => {
                let dupContextList = contextCandidates.map(item => {
                  item.selected = false;
                  return item;
                });
                if (!selectAll) {
                  dupContextList = contextCandidates.map(item => {
                    item.selected = true;
                    return item;
                  });
                }
                setContextCandidates(dupContextList);
                setSelectAll(!selectAll);
              }}
            />
          </Col>
          </Row>
        <Row style={{ marginBottom: "15px" }}>
          <Col md={3} style={{ marginTop: "15px" }}>
            <ButtonSecondary
              disabled={!contextCandidates.some(candidate => candidate.selected)}
              onClick={() => liberarCandidatos()}
              name="Liberar Candidatos"
            />
          </Col>
          <Col md={3} style={{ marginTop: "15px" }}>
            <ButtonSecondary
              disabled={!contextCandidates.some(candidate => candidate.selected)}
              onClick={() => exportarCandidatos()}
              name="Exportar Candidatos"
            />
          </Col>
          <Col md={3} style={{ marginTop: "15px" }}>
            <ButtonSecondary
              disabled={!contextCandidates.some(candidate => candidate.selected)}
              onClick={() => cancelarCandidatos()}
              name="Desativar Candidato"
            />
          </Col>
          <Col md={3} style={{ marginTop: "15px" }}>
            <ButtonSecondary
              disabled={!contextCandidates.some(candidate => candidate.selected)}
              onClick={() => resetarSenhaCandidato()}
              name="Resetar Senha"
            />
          </Col>
        </Row>

        {candidates.candidatos &&
          !agruparPorVaga &&
          renderCandidatesTable(candidates)}

        {agruparPorVaga && renderCandidatesByGroupTable(candidates)}
        {/* <ButtonSecondary
          disabled={!hasMore}
          onClick={loadMore}
          isLoading={isLoading}
          name={<FormattedMessage id="sharedItems.loadMore" />}
        /> */}
      </Body>
    </React.Fragment>
  );
};

const mapDispatchToProps = dispatch => ({
  candidateVacancysDocs: filter => dispatch(documentsAction.candidatesVacancysDocsRequest(filter)),
  candidateFiles: id => dispatch(documentsAction.candidateFilesRequest(id)),
  setStatusFileRequest: payload => dispatch(documentsAction.candidateSetStatusFileRequest(payload)),
  requestInputValues: inputs => dispatch(formInputsActions.formInputsRequest(inputs)),
  messagePublication: messages => dispatch(messageAction.messagePublication(messages)),
  releaseStageForCandidatesRequest: payload => dispatch(documentsAction.releaseStageForCandidatesRequest(payload)),
  requestExportPersonalInformations: payload => dispatch(candidatesAction.candidatesExportPersonalInformationRequest(payload)),
  releaseCancellationForCandidatesRequest: payload => dispatch(documentsAction.releaseCancellationForCandidatesRequest(payload)),
  releasePasswordReset: payload => dispatch(candidatesAction.candidatesPasswordResetRequest(payload)),
});

const mapStateToProps = state => ({
  isLoading: state.documents.isLoading,
  candidates: state.documents.candidates,
  placesOfWork: state.formInputs.placeOfWork,
  hasMore: state.documents.hasMore,
  quantidadeItens: state.documents.quantidadeItens,
  pagination: state.documents.pagination,
});

export default connect(mapStateToProps, mapDispatchToProps)(ListDocumentsCandidates);

ListDocumentsCandidates.propTypes = {
  candidates: PropTypes.func,
  hasMore: PropTypes.any,
  quantidadeItens: PropTypes.any,
};

ListDocumentsCandidates.defaultProps = {
  candidates: () => { }
};
